var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChanged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.a,.b{stroke:#15b22c;stroke-width:3px;}.b{stroke-linecap:round;stroke-linejoin:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-912.102 -366.102)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(912.102 366.102)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 49,
    cy: 49,
    r: 49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 49,
    cy: 49,
    r: 47.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-3921.732,4613.371l10.757,9.924,25.584-27.764",
    transform: "translate(4864.663 -4194.312)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanged);
export default __webpack_public_path__ + "static/media/changed.0d439fcc84b323128fb9efb789acecea.svg";
export { ForwardRef as ReactComponent };